const getAge = (dateOfBirth: string | null, dateOfDeath?: string | null) => {
  if (!dateOfBirth) return null;

  const birthDate = new Date(dateOfBirth);
  // endDate will usually be today, but if the person is deceased, it will be their date of death used for age calculation
  const endDate = dateOfDeath ? new Date(dateOfDeath) : new Date();

  let age = endDate.getFullYear() - birthDate.getFullYear();
  const monthDiff = endDate.getMonth() - birthDate.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && endDate.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

export default getAge;
